/**
 * 콘솔 화면 머리 — 제목 · 요약칩 · 설명 한 벌 (2026-09-09).
 *
 * ★★ **경로(breadcrumb)를 그리지 않는다.** 셸(`ConsolePage`)이 이미
 *    `관리 콘솔 › 그룹 › 탭` 을 화면 위에 그린다. 머리에서 한 번 더 그리면 **같은 경로가
 *    두 줄로 겹친다** — 목록 규격 첫 판(#1089~#1092)이 실제로 그렇게 나갔고, 이 파일이
 *    그것을 바로잡은 자리다. 경로는 셸의 몫이다.
 *
 * 콘솔 화면의 머리가 네 갈래로 갈려 있었다 — `svc-cat__head`(6) · `<h2>`(2) · `<h3>`(1) ·
 * 좌측 패널 머리만(1). 이 부품이 그 자리를 하나로 모은다.
 */
import type { ReactNode } from 'react';
import './console-list.css';

export interface ConsoleScreenHeadProps {
  title: string;
  /** 제목 옆 요약 칩 (예: '17개 · 노출 14'). 한 줄로 요약되는 수만 적는다. */
  kpi?: string;
  /** 한 문장 설명. 길어지면 도움말로 보낸다(정본 P8). */
  desc?: ReactNode;
  /** 제목 줄 오른쪽에 붙일 것 — 목록 화면은 툴바가 받으므로 대개 비어 있다. */
  actions?: ReactNode;
}

export function ConsoleScreenHead({ title, kpi, desc, actions }: ConsoleScreenHeadProps) {
  return (
    <header className="cl__head">
      <div className="cl__title">
        <h2>{title}</h2>
        {kpi && <span className="cl__kpi">{kpi}</span>}
        {actions && <><span className="cl__spacer" />{actions}</>}
      </div>
      {desc && <p className="cl__desc">{desc}</p>}
    </header>
  );
}
